export default __webpack_public_path__ + "static/media/마크라메_모바일.a1606b66.jpg";